<template>
  <div>
    <v-layout row wrap>
       <v-flex xs12 sm12 md12>
         <v-toolbar class="primary white--text">
            <v-toolbar-title class="headline text-xs-center">
              Print Management
            </v-toolbar-title>
            <v-spacer></v-spacer>  
            <v-card-actions class="justify-center">
              <v-btn 
                @click="addTerm"
                outlined
                large>
                <v-icon left color='teal'>
                add
                </v-icon> 
                NEW PRINT 
              </v-btn>
            </v-card-actions>
          </v-toolbar> 
        <v-data-table
          :headers="termsListHeader"
          :items="termsListByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td>
              <b>{{getFirmName(props.item.firm)}}</b>
            </td>
            <td>
              <template v-for="cbank in props.item.bank">
                <v-chip
                    class="ma-2"
                    color="primary"
                    :key="cbank"
                    style="color : white"
                  >
                    {{getBankName(cbank)}}
                  </v-chip>
              </template>
            </td>
             <td>
              <b>{{ props.item['termsAndConditions']}}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editTerm(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteTerm(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addTermsDialog" max-width="1000px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Terms and Conditions</span>
          <v-spacer/>
          <v-btn icon dark @click.native="addTermsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-select
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-if="!currentTerms['.key']"
                  v-model="currentTerms.firm"
                ></v-select>
                <v-text-field
                  dense
                  v-else
                  :value="getFirmName(currentTerms.firm)"
                  :disabled="true"
                  label="Select Firm"                 
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                 <v-select
                        dense
                        :items="banksByFirms"
                        :multiple="true"
                        label="Select Bank"
                        v-model="currentTerms.bank"
                      ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.isTradeDiscount"
                  :label="`${
                    'Display Trade Discount in PDF: '+ (currentTerms.isTradeDiscount ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.isPurity"
                  :label="`${
                    'Display Purity in PDF: '+ (currentTerms.isPurity ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.purityRemark"
                  :label="`${
                    'Display Purity Msg in PDF: '+ (currentTerms.purityRemark ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
               <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.isSpecialCharge"
                  :label="`${
                    'Display Special Charge in PDF: '+ (currentTerms.isSpecialCharge ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentTerms.isGrossWeight"
                  :label="`${
                    'Display Gross Weight in PDF: '+ (currentTerms.isGrossWeight ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.isNetWeight"
                  :label="`${
                    'Display Net Weight in PDF: '+ (currentTerms.isNetWeight ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.isLessStone"
                  :label="`${
                    'Display Less(Stone) in PDF: '+ (currentTerms.isLessStone ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.fat"
                  :label="`${
                    'Display Fat in PDF: '+ (currentTerms.fat ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentTerms.isGSTGroupingDisabled"
                  :label="`${
                    'Disable GST Grouping in PDF: '+ (currentTerms.isGSTGroupingDisabled ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentTerms.isTotalAmount"
                  :label="`${
                    'Display Total Amount: '+ (currentTerms.isTotalAmount ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.isPreviousDue"
                  :label="`${
                    'Display Previous Due invoices: '+ (currentTerms.isPreviousDue ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.isEstimate"
                  :label="`${
                    'Display Estimates: '+ (currentTerms.isEstimate ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentTerms.isPreviousCurrentTotalBalance"
                  :label="`${
                    'Display Previous , Current and Total Balance: '+ (currentTerms.isPreviousCurrentTotalBalance ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                 v-model="currentTerms.isMajorUnitDisplay"
                 :label="`${
                   'Display Major Unit Details : '+ (currentTerms.isMajorUnitDisplay ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                 v-model="currentTerms.isBlankHeader"
                 :label="`${
                   'Display Blank Header in PDF : '+ (currentTerms.isBlankHeader ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                 v-model="currentTerms.isPaymentType"
                 :label="`${
                   'Display Payment Type in PDF : '+ (currentTerms.isPaymentType ? 'YES': 'NO') 
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-textarea
                  background-color="grey darken-1"
                  color="black" 
                  name="input-7-1"
                  box
                  label="Terms and Conditions"
                  v-model="currentTerms.termsAndConditions"
                ></v-textarea>
              </v-flex>
                <v-flex xs12 sm12 md12>
                <v-textarea
                  background-color="grey darken-1"
                  color="black" 
                  name="input-7-1"
                  max="20"
                  box
                  label="Greeting Message"
                  v-model="currentTerms.greetingMessage"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm12 md12>
               <span>
                  <label for="filesLogo" class="title mat-raised-button">
                    <span style="font-weight: bold; color: #2727b0;">{{currentTerms.printLogo ? 'Change Logo Image' : 'Upload Logo Image'}}</span>
                  </label>
                <input id="filesLogo" @change="uploadChangeLogo($event)" accept=".png,.jpg" style="visibility:hidden;" type="file">
                </span>
                <span v-if="printLogoImage">{{printLogoImage.name}}</span>
                <span v-if="uploadValue!=0">{{uploadValue}}%</span>
               </v-flex>
              <v-flex xs12 sm12 md12 v-if="currentTerms.printLogo">
                <img :src="currentTerms.printLogo" height="250px" width="250px" style="object-fit: cover">
              </v-flex>
              <v-flex xs12 sm12 md12>
                <span>
                  <label for="filesSig" class="title mat-raised-button">
                    <span style="font-weight: bold; color: #2727b0;">{{currentTerms.signature ? 'Change Signature Image' : 'Upload Signature Image'}}</span>
                  </label>
                  <input id="filesSig" @change="uploadChangeSignature($event)" accept=".png,.jpg" style="visibility:hidden;" type="file">
                </span>
                <span v-if="signatureImage">{{signatureImage.name}}</span>
                <span v-if="uploadValue!=0">{{uploadValue}}%</span>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="currentTerms.signature">
                <img :src="currentTerms.signature" height="100px" width="250px" style="object-fit: cover">
               </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="saveTerms" flat v-if="!currentTerms['.key']">Save</v-btn>
          <v-btn
            color="blue darken-1"
            @click="updateTerms"
            flat
            v-if="!!currentTerms['.key']"
          >Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import firebase from 'firebase'; 
let logoPath = 'print-images/';
let signaturePath = 'signature-images/';
export default {
  data() {
    return {
      addTermsDialog: false,
      currentTerms: {
        firm: null,
        termsAndConditions: "",
        bank: [],
        brand : null
      },
      printLogoImage : null,
      signatureImage : null,
      uploadValue : 0,
      termsList: [],
      termsListHeader: [
        // { text: "Print- ID", value: "Term - ID" },
        { text: "Firm", value: "Name" },
        { text: "Banks", value: "Description" },
        { text: "Terms and Conditions", value: "Description" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" }
      ],
    };
  },
  created() {
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    firmsByBrand() {
      let alreadyExistsSettingsFirm = this.termsListByBrand;
      return this.firms
        .filter(item => {
         return (item["brand"] === this.selectedBrand && 
          (!_.find(alreadyExistsSettingsFirm, function (o) { return o['firm'] ==item['.key']; })))
        })
        .map(item => {
          return {
            text: item["name"],
            value: item[".key"]
          };
      });
    },
    banksByFirms() {
      return this.banks
        .filter(item => (item["brand"] === this.selectedBrand )
        && (this.currentTerms.firm ? item['firm'] === this.currentTerms.firm : false)
        )
        .map(item => {
          return {
            text: item["bankName"] + " | " + item["accountnumber"],
            value: item[".key"]
          };
      });
    },
    termsListByBrand() {
      return this.termsAndConditions.filter(item => item["brand"] === this.selectedBrand);
    }
  },
  methods: {
    saveTerms() {
      if(this.printLogoImage || this.signatureImage) {
        this.uploadAndSave(true);
      } else {
        this.$root.$firebaseRefs.termsAndConditions.push(this.currentTerms);
        this.addTermsDialog = false;
      }
    },
    deleteImage(name,filePath){
      let storagePath = firebase.storage().ref();
      storagePath.child(filePath + `${name}`).delete();
    },
    async uploadAndSave(isSave){
      if(this.printLogoImage && this.currentTerms.printLogo) {
        this.deleteImage(this.currentTerms.logoFileName,logoPath)
      }
      if(this.signatureImage && this.currentTerms.signature) {
        this.deleteImage(this.currentTerms.signatureFileName,signaturePath)
      }

      if(this.printLogoImage) {
        await this.upload(this.printLogoImage,logoPath,['printLogo','logoFileName']).then(() => {
          this.printLogoImage = null
        })
      }
      if(this.signatureImage) {
          await this.upload(this.signatureImage,signaturePath,['signature','signatureFileName']).then(() => {
          this.signatureImage = null
        });
      }
      if(isSave) {
        this.saveTerms();
      } else {
        this.updateTerms();
      }
    },

    upload(image,filePath,fields){
      return new Promise(resolve => {
        let fileName = new Date().getTime() + "_" + image.name
        const storageRef=firebase.storage().ref(filePath + `${fileName}`).put(image);
        storageRef.on(`state_changed`,snapshot=>{
        this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
          }, error=>{console.log(error.message)},
        ()=>{
          this.uploadValue=100;
            storageRef.snapshot.ref.getDownloadURL().then((url)=>{
              this.uploadValue = 0;
              this.currentTerms[fields[0]] = url;
              this.currentTerms[fields[1]] = fileName;
              resolve();
              });
            }      
        );
      })
    },
    
    uploadChangeLogo(event){
      this.printLogoImage = event.target.files[0];
    },
    uploadChangeSignature(event){
      this.signatureImage = event.target.files[0];
    },
    addTerm() {
      this.currentTerms = {
        firm: null,
        bank: [],
        termsAndConditions : '',
        brand : this.selectedBrand
      };
      this.addTermsDialog = true;
    },
    getFirmName(e){
      let firm;
      if (this.firms && this.selectedBrand) {
        firm =this.firms.filter(item => item['.key'] === e)[0]
      }
      if(firm)
      return firm.name
    },
    getBankName(e){
      let bank =this.banks.filter(item => item['.key'] === e)[0]
      if(bank)
      return bank.bankName + " | " + bank["accountnumber"]
    },
    updateTerms() {
       if(this.printLogoImage || this.signatureImage) {
        this.uploadAndSave(false);
      } else {
        let key = this.currentTerms[".key"];
        delete this.currentTerms[".key"];
        this.$root.$firebaseRefs.termsAndConditions.child(key).set(this.currentTerms);
        this.currentTerms = {
          firm: null,
          bank: [],
          termsAndConditions : '',
          brand : this.selectedBrand,
          greetingMessage : "",
        };
        this.addTermsDialog = false;
      }
    },
    editTerm(term) {
      this.currentTerms = JSON.parse(JSON.stringify(term));
      this.addTermsDialog = true;
    },
    deleteTerm(term) {
      if (window.confirm("Do you want to Delete " + term.name + "?")) {
      if(term.printLogo) {
        this.deleteImage(term.logoFileName,logoPath)
      }
      if(term.signature) {
        this.deleteImage(term.signatureFileName,signaturePath)
      }
        this.$root.$firebaseRefs.termsAndConditions.child(term[".key"]).remove();
      }
    },
  
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/Print/printSettings.vue